module.exports = function () {
    $('[data-toggle="tooltip"]').tooltip();
};
